import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { LogIn } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { performLogout } from '@/lib/auth/performLogout'

export const Route = createFileRoute('/_AuthLayout/logout')({
  component: LogoutPage,
})

function LogoutPage() {
  const navigate = useNavigate()

  useEffect(() => {
    void performLogout()
  }, [])

  return (
    <div className="max-w-md mx-auto">
      <div className="rounded-2xl border border-border bg-card p-8 shadow-lg">
        <div className="flex flex-col items-center space-y-6 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <LogIn className="h-8 w-8 text-primary" />
          </div>

          <div className="space-y-2">
            <h2 className="text-2xl font-semibold">You've been signed out</h2>
            <p className="text-sm text-muted-foreground">
              Thanks for using Moly. Come back soon!
            </p>
          </div>

          <div className="flex flex-col gap-3 w-full">
            <Button
              onClick={() => {
                navigate({ to: '/auth', replace: true })
              }}
              className="w-full"
            >
              Sign in again
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
